export enum TabValue {
  details = "details",
  leaningoutcomes = "learningoutcomes",
}

export interface DataH5p {
  source?: string;
}

export interface PreviewBaseProps {
  onGoLive: () => any;
}
